<div class="sr-cs-role"><span [class]="iconClass"></span> {{ label }}</div>

<po-table *ngIf="showMore"
  class="sr-git-table"
  [p-columns]="columns"
  [p-items]="items"
  [p-height]="tableHeight"
  [p-selectable]="true"
  [p-single-select]="true"
  [p-selectable-entire-line]="true"
  [p-hide-select-all]="true"
  [p-hide-columns-manager]="true"
  [p-hide-table-search]="false"
  [p-filter-type]="filterType"
  p-spacing="small"
  [p-show-more-disabled]="!hasMoreHistory"
  [p-loading-show-more]="loadingMoreHistory"
  (p-show-more)="showMoreClick.emit()"
  (p-selected)="selected.emit($event)"
  (p-unselected)="unselected.emit($event)">
  <ng-template p-table-cell-template let-column="column" let-row="row">
    <ng-container *ngIf="column.property === 'descriptionShort'">
      <span class="sr-description-tooltip"
        [p-tooltip]="row.descriptionFull || row.descriptionShort"
        p-tooltip-position="top">
        {{ row.descriptionShort }}
      </span>
    </ng-container>
  </ng-template>
</po-table>

<po-table *ngIf="!showMore"
  class="sr-git-table"
  [p-columns]="columns"
  [p-items]="items"
  [p-height]="tableHeight"
  [p-selectable]="true"
  [p-single-select]="true"
  [p-selectable-entire-line]="true"
  [p-hide-select-all]="true"
  [p-hide-columns-manager]="true"
  [p-hide-table-search]="false"
  [p-filter-type]="filterType"
  p-spacing="small"
  (p-selected)="selected.emit($event)"
  (p-unselected)="unselected.emit($event)">
  <ng-template p-table-cell-template let-column="column" let-row="row">
    <ng-container *ngIf="column.property === 'descriptionShort'">
      <span class="sr-description-tooltip"
        [p-tooltip]="row.descriptionFull || row.descriptionShort"
        p-tooltip-position="top">
        {{ row.descriptionShort }}
      </span>
    </ng-container>
  </ng-template>
</po-table>
